// removed by extract-text-webpack-plugin
module.exports = {"text":"_37I4Ijtd3DK4zVNc","delimiter":"_3N4-jAUEVf8aIpR7","faded":"wt5Zf7B9oWXqt4gW"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/PopupHeaderText.pcss
// module id = 492
// module chunks = 1